import React from 'react';
import { Box } from '@mui/material';

interface CardContainerProps {
    backgroundImageUrl: string | undefined;
    children: React.ReactNode;
}

const CardContainer: React.FC<CardContainerProps> = ({ backgroundImageUrl, children }) => {
    return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh"
            sx={{
                backgroundImage: `url("${backgroundImageUrl}")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}>
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh" width="100%"
                sx={{
                    background: '#000',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    opacity: '0.2',
                    position: "absolute"
                }}>
            </Box>
            {children}
        </Box>
    );
};

export default CardContainer;